import { render } from "./CopyrightOnlyText.vue?vue&type=template&id=3ffe4a10"
import script from "./CopyrightOnlyText.vue?vue&type=script&lang=js"
export * from "./CopyrightOnlyText.vue?vue&type=script&lang=js"

import exportComponent from "D:\\others\\ysj\\leer\\wisdom\\html\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__